import DynamicHeight from "./DynamicHeight";

new DynamicHeight({
	scope: 'header',
	name: 'header-height'
});

new DynamicHeight({
    scope: '[data-scope="row-height"]',
    name: 'row-height',
    wrappers: ['[data-scope="row-height"]'],
});
